import React from 'react';

const DisclaimerFooter = () => {
    return (
        <div className="w-full max-w-5xl mx-auto mt-4 p-4 text-center bg-slate-900/40 border-t border-slate-700/60 rounded-b-xl">
            <p className="text-sm text-gray-400">
                💬 <strong>Remember:</strong> This is a research tool for educational purposes. You are responsible for all trading decisions.
            </p>
        </div>
    );
};

export default DisclaimerFooter;